// Helper Library
(function(helper, $) {
    // This is now a utility function to "Get the Document Hash"
    helper.getDocumentHash = function (urlString) {
        var hashValue = "";

        if (urlString.indexOf('#') != -1) {
            hashValue = urlString.substring(parseInt(urlString.indexOf('#')) + 1);
        }
        return hashValue;
    };
})(this.helper = this.helper || {}, jQuery);


var __breakpoint = 767;

$(document).ready(function() {
	init_link();
	init_faq();
	// init_scroll();
});

//PCナビ　スクロールして現れる
$(window).on('scroll', function() {
	// init_scroll();
});

function init_scroll() {
	if($(window).width() <= __breakpoint) {
        if ($(window).scrollTop() > 200 && $(window).scrollTop() < $('#footer').offset().top - $(window).height()) {
        	$('#globBanner').fadeIn().css('display', 'flex');
        } else {
        	$('#globBanner').fadeOut();
        }
	}
}

function init_link () {
	$('.btn').click(function(e) {
		var hrefVal = $(this).attr('href');
		if(hrefVal && hrefVal != "") {
			var id = helper.getDocumentHash(hrefVal);
			if(id && $('#' + id).length > 0) {
				e.preventDefault();
				e.stopPropagation();
				if($('#globNaviCheck:checked')) {
					$('#globNaviCheck').trigger("click");
				}
			    $([document.documentElement, document.body]).animate({
			        scrollTop: $("#" + id).offset().top
			    }, 1000);
		    }
	    }
	});
}

function init_faq() {
	var aa = $('#faqList dt');
	$('.btn_accordion').click(function(){
		var parent = $(this).closest('.accordion');
		if(parent.hasClass('opened')) {
			parent.removeClass('opened');
		} else {
			parent.addClass('opened');
		}
	});
}

//slide
(function () {
    $('#slider').slick({
        centerMode: true,
        centerPadding: '3rem',
        dots: true,
        focusOnSelect: true,
        arrows: false,
        responsive: [{
            breakpoint: 749,
            settings: {
                centerPadding: '30px',
            }
        },
        ]
    });
})();

//ラジオボタン
(function () {
    $('[name="area_id"]:radio').change(function () {
        if ($('[id=tokyo_input]').prop('checked')) {
            $('.radio_tokyo').next().addClass('active');
            $('.radio_osaka').next().removeClass('active');
            $('.radio_kyoto').next().removeClass('active');
            $('.radio_no').next().removeClass('active');
            $('.tokyo_wrap').addClass('active');
            $('.osaka_wrap').removeClass('active');
            $('.kyoto_wrap').removeClass('active');
            $('.no_wrap').removeClass('active');
        } else if ($('[id=osaka_input]').prop('checked')) {
            $('.radio_osaka').next().addClass('active');
            $('.radio_tokyo').next().removeClass('active');
            $('.radio_kyoto').next().removeClass('active');
            $('.radio_no').next().removeClass('active');
            $('.osaka_wrap').addClass('active');
            $('.tokyo_wrap').removeClass('active');
            $('.no_wrap').removeClass('active');
            $('.kyoto_wrap').removeClass('active');
        } else if ($('[id=kyoto_input]').prop('checked')) {
            $('.radio_kyoto').next().addClass('active');
            $('.radio_tokyo').next().removeClass('active');
            $('.radio_osaka').next().removeClass('active');
            $('.radio_no').next().removeClass('active');
            $('.kyoto_wrap').addClass('active');
            $('.tokyo_wrap').removeClass('active');
            $('.no_wrap').removeClass('active');
            $('.osaka_wrap').removeClass('active');
        } else if ($('[id=no_input]').prop('checked')) {
            $('.radio_no').next().addClass('active');
            $('.radio_tokyo').next().removeClass('active');
            $('.radio_osaka').next().removeClass('active');
            $('.radio_kyoto').next().removeClass('active');
            $('.no_wrap').addClass('active');
            $('.tokyo_wrap').removeClass('active');
            $('.kyoto_wrap').removeClass('active');
            $('.osaka_wrap').removeClass('active');
        }
    });
});

//ラジオボタン
(function () {
    $('[name="sex"]:radio').change(function () {
        if ($('[id=woman]').prop('checked')) {
            $('.radio_woman').next().addClass('active');
            $('.radio_male').next().removeClass('active');
            $('.radio_no_answer').next().removeClass('active');
        } else if ($('[id=male]').prop('checked')) {
            $('.radio_male').next().addClass('active');
            $('.radio_woman').next().removeClass('active');
            $('.radio_no_answer').next().removeClass('active');
        } else if ($('[id=no_answer]').prop('checked')) {
            $('.radio_no_answer').next().addClass('active');
            $('.radio_woman').next().removeClass('active');
            $('.radio_male').next().removeClass('active');
        }
    });
});


(function () {
    $('.checkbox-parts').on('click', function () {
        if ($(this).hasClass('active')) {
            $(this).removeClass('active');
            $(this).parent().next().children().removeClass('active');
            $('.reserve_btn button').removeClass('active');
        } else {
            $(this).addClass('active');
            $(this).parent().next().children().addClass('active');
            $('.reserve_btn button').addClass('active');
        }
    });
});

// バリデーション
(function () {
    //必須項目が空かどうかフラグ
    $('.js-validation').validate({
        rules: {
            area_id: {
                required: true,
            },

            surname: {
                required: true,
            },

            name: {
                required: true,
            },

            furigana_surname: {
                required: true,
            },

            furigana_name: {
                required: true,
            },

            company: {
                required: true,
            },

            email: {
                required: true,
            },

            tel: {
                required: true,
            },

            check: {
                required: true,
            },

            first_choice_2: {
                required: true,
            },

            second_choice_2: {
                required: true,
            },

            first_choice_3: {
                required: true,
            },

            second_choice_3: {
                required: true,
            },

            reservation_date: {
                required: true,
            },
        },

        messages: {
            area_id: {
                required: '※ご希望のクリニックを選択してください。',
            },

            surname: {
                required: '「性」を入力してください。',
            },

            name: {
                required: '「名」を入力してください。',
            },

            furigana_surname: {
                required: 'ひらがなのみ入力してください。',
            },

            furigana_name: {
                required: '「めい」を入力してください。',
            },

            company: {
                required: '※貴社名が未入力です。',
            },

            email: {
                required: 'メールアドレスは有効なメールアドレスではありません',
            },

            tel: {
                required: '電話番号は数字のみ使用できます',
            },

            check: {
                required: '内容をご確認の上、チェックを入れてください。',
            },

            first_choice_2: {
                required: '第1希望日を選択してください',
            },

            second_choice_2: {
                required: '第2希望日を選択してください',
            },

            first_choice_3: {
                required: '第1希望日を選択してください',
            },

            second_choice_3: {
                required: '第2希望日を選択してください',
            },

            reservation_date: {
                required: 'ご希望日を選択してください',
            },
        },

        // エラーメッセージ出力箇所
        errorPlacement: function (error, element) {
            var name = element.attr('name');
            error.appendTo($('.is-error-' + name));
            // console.log(name);
        },

        errorElement: "span",
        errorClass: "is-error",
    })
});

$(function () {
    // 東京
    $(document).on('click', '.calendar_table .wCircle', function (e) {
        var self = $(this);
        var is_active = self.hasClass('active');
        var reservation_date_label = self.attr('data-reservation_date_label');
        var reservation_date = self.attr('data-reservation_date');
        var reservation_hour = self.attr('data-reservation_hour');

        $('.tokyo_wrap .reservation_date_label').text('選択されていません');
        $('#reservation_date_label').val('');
        $('#reservation_date').val('');
        $('#reservation_hour').val('');
        self.closest('.calendar_table').find('.wCircle').each(function (index, element) {
            $(element).removeClass('active');
        });

        if (is_active) {
            self.removeClass('active');
        } else {
            self.addClass('active');
            $('.tokyo_wrap .reservation_date_label').text(reservation_date_label);
            $('#reservation_date_label').val(reservation_date_label);
            $('#reservation_date').val(reservation_date);
            $('#reservation_hour').val(reservation_hour);
        }
    });

    // 東京以外
    $(document).on('click', 'nav .wCircle', function (e) {
        var self = $(this);
        var is_active = self.hasClass('active');
        var reservation_date_label = self.attr('data-reservation_date_label');
        var reservation_date = self.attr('data-reservation_date');

        var js_choice = $('.js_choice.active');
        var area_id = js_choice.attr('data-area_id');
        var type = js_choice.attr('data-type');

        self.closest('.area_wrap').find('.wCircle').each(function (index, element) {
            $(element).removeClass('active');
        });

        if (is_active) {
            self.removeClass('active');
            js_choice.val('');
            js_choice.next('input').val('');
            if (area_id == 2) {
                $('.osaka_wrap .reservation_date_label.' + type).text('').css('color', '#000');
            } else if (area_id == 3) {
                $('.kyoto_wrap .reservation_date_label.' + type).text('').css('color', '#000');
            }
        } else {
            self.addClass('active');
            js_choice.val(reservation_date);
            js_choice.next('input').val(reservation_date_label);
            if (area_id == 2) {
                $('.osaka_wrap .reservation_date_label.' + type).text(reservation_date_label).css('color', '#000');
            } else if (area_id == 3) {
                $('.kyoto_wrap .reservation_date_label.' + type).text(reservation_date_label).css('color', '#000');
            }
        }

        // 日付選択でモーダルを閉じる（暫定処理）
        if ($('.overlay').hasClass('open')) {
            $('.overlay').removeClass('open');
            $('.js_choice').removeClass('active');
            $('.area_wrap').each(function (index, element) {
                $(element).removeClass('active');
            });
            $('nav').find('.wCircle').each(function (index, element) {
                $(element).removeClass('active');
            });
            $('nav').removeClass('open');
        }
    });
});

$(function () {
    $('.js_choice').on('click', function () {
        var self = $(this);
        var area_id = self.attr('data-area_id');
        var type = self.attr('data-type');

        self.val('');
        self.next('input').val('');
        if (area_id == 2) {
            $('.osaka_wrap .reservation_date_label.' + type).text('').css('color', '#000');
        } else if (area_id == 3) {
            $('.kyoto_wrap .reservation_date_label.' + type).text('').css('color', '#000');
        }

        if ($(this).hasClass('active')) {
            $(this).removeClass('active');
            $('.area_wrap.area_id_' + area_id).removeClass('active');
            $('nav').removeClass('open');
            $('.overlay').removeClass('open');
        } else {
            $(this).addClass('active');
            $('.area_wrap.area_id_' + area_id).addClass('active');
            $('nav').addClass('open');
            $('.overlay').addClass('open');
        }
    });

    $('.overlay, nav .close_btn').on('click', function () {
        if ($('.overlay').hasClass('open')) {
            $('.overlay').removeClass('open');
            $('.js_choice').removeClass('active');
            $('.area_wrap').each(function (index, element) {
                $(element).removeClass('active');
            });
            $('nav').find('.wCircle').each(function (index, element) {
                $(element).removeClass('active');
            });
            $('nav').removeClass('open');
        }
    });
});

$(function () {
    $(document).on('click', 'nav button.prev:not(.disabled)', function (e) {
        var self = $(this);
        $('nav').each(function (index, element) {
            $(element).removeClass('active');
        });
        self.closest('nav').prev().addClass('active');
    });

    $(document).on('click', 'nav button.next:not(.disabled)', function (e) {
        var self = $(this);
        $('nav').each(function (index, element) {
            $(element).removeClass('active');
        });
        self.closest('nav').next().addClass('active');

    });
});

$(function () {
    $('.js_top_btn').on('click', function () {
        $(this).prev('.js_close').toggleClass('open');
        $(this).prev().prev().toggleClass('opacity');
        $(this).toggleClass('active');
    });
});

$(function () {
    $(".q_a_list .open").on('click', function () {
        $(this).toggleClass("active");
        $(this).next('.close').fadeToggle(100);
    });
});

$(function () {
    $(".symptoms").on('click', function () {
        $(this).toggleClass('active');
        $('.mv_close').fadeToggle(100);
    });
});